import { Component } from '@angular/core';

  import { ChangePassword, Notify, SessionService, SharedService, ConfigService, User } from 'baseline-lib';
import { CustomToast } from '../../shared/services/custom-toast';
import { Global } from '../../../global/global';
import { NavController } from 'ionic-angular';
  
  // import { SessionService } from '../../_service/session.service';
  // import { SharedService } from '../../_service/shared.service';
  // import { ChangePassword } from '../../_models/common/changePassword';
  // import { Notify } from '../../_models/common/notify';
  
  @Component({
    selector: 'change-password',
    templateUrl: 'change-password.html'
  })
  export class ChangePasswordComponent {
  
    _authUser: any;
    _changePassword: ChangePassword;
    _notify: Notify;
    _show: number;
  
    constructor(
      private _sessionService: SessionService, private _configService:ConfigService,
      private _sharedService: SharedService, private globalData:Global,
      private toast: CustomToast, private navCtrl:NavController
    ) {
      this._changePassword = new ChangePassword();
      this._notify = new Notify();
      this._show = 1;
    }
  
    ngOnInit() {
    }
  
    reset() {
      this._changePassword.resetFields();
    }
  
    onClick(txtBoxId: string) {    
      var element = <HTMLScriptElement>document.getElementById(txtBoxId);
      if (element) {
        element.type == 'text' ? element.type = 'password' : element.type = 'text'
      }
    }
  
    validatePassword() {
      if (this._changePassword.op == undefined || this._changePassword.np == undefined || this._changePassword.cp == undefined || this._changePassword.op == "" || this._changePassword.np == "" || this._changePassword.cp == "") {
        this._notify.errorMsg = "All fields are mandatory."
        this.toast.showError(this._notify.errorMsg);

        setTimeout(() => {
          this._notify.errorMsg = "";
        }, 2000);
        return false;
      }
      if (this._changePassword.np != this._changePassword.cp) {
        this._notify.errorMsg = "Confirm password doesnt match."
        this.toast.showError(this._notify.errorMsg);

        setTimeout(() => {
          this._notify.errorMsg = "";
        }, 2000);
        return false;
      }
      return true
    }
  
    callChangePassword() {
      this._authUser = this._sessionService.getAuthUser();    
      if (this._authUser) {
        if (this.validatePassword()) {
          this._sharedService.showLoader();
          this._changePassword.tokenId = this._authUser.tokenNo;
          this._sharedService.getNewPassword(this._changePassword).subscribe(
            data => {
              if (data) {
                this.reset();
                this._sharedService.hideLoader();
                this._notify.successMsg = data.msg;
                this.toast.showSuccess(this._notify.successMsg);
                this.logOut();
                setTimeout(() => {
                  this._notify.successMsg = '';
                }, 3000);
              }
            },
            error => {
              if (error.msg) {
                this._notify.errorMsg = error.msg;
                 this.toast.showError(this._notify.errorMsg);
              }
              else {
                this._notify.errorMsg = error.message;
                this.toast.showError(this._notify.errorMsg);
              }
              this.toast.showError(this._notify.errorMsg);

              this._sharedService.hideLoader();
              setTimeout(() => {
                this._notify.errorMsg = '';
              }, 3000);
            }
          );
        }
      }
    }

    logOut() {
      localStorage.clear();
      this.globalData.selectedMenu = "home";
      this.globalData.isLoggedIn = false;
      this.globalData.authUser = new User();
      this._sessionService.authUser = undefined;
      
      this._sharedService.loginSubject.next(false);
      if (!this._configService.isplayerLogin())
        this.navCtrl.setRoot(this.navCtrl.getActive().component);
    }
  }
  
  


// WEBPACK FOOTER //
// ./src/app/retailer/change-password/change-password.ts